import type { PlayerStats } from "../types";

const ROLE_ORDER = ["TOP", "JUNGLE", "MIDDLE", "BOTTOM", "UTILITY", "SUPPORT"];

export type TeamComposition = {
  BLUE: PlayerStats[];
  RED: PlayerStats[];
};

export function sortParticipantsByTeamAndRole(
  participants: PlayerStats[]
): TeamComposition {
  const grouped: TeamComposition = {
    BLUE: [],
    RED: [],
  };

  // Group by team
  participants.forEach((p) => {
    if (p.team === "BLUE") {
      grouped.BLUE.push(p);
    } else if (p.team === "RED") {
      grouped.RED.push(p);
    }
  });

  // Sort each team by role priority
  const sortByRole = (a: PlayerStats, b: PlayerStats) => {
    const roleA = ROLE_ORDER.indexOf(a.role.toUpperCase());
    const roleB = ROLE_ORDER.indexOf(b.role.toUpperCase());
    return roleA - roleB;
  };

  grouped.BLUE.sort(sortByRole);
  grouped.RED.sort(sortByRole);

  return grouped;
}

export function getTotalKda(participants: PlayerStats[]): {
  kills: number;
  deaths: number;
  assists: number;
} {
  return participants.reduce(
    (acc, player) => {
      acc.kills += player.kills;
      acc.deaths += player.deaths;
      acc.assists += player.assists;
      return acc;
    },
    { kills: 0, deaths: 0, assists: 0 }
  );
}

export function getTotalGold(participants: PlayerStats[]): number {
  return participants.reduce((acc, player) => acc + player.goldEarned, 0);
}

export function getItemImage(id: number): string {
  return `https://ddragon.leagueoflegends.com/cdn/15.14.1/img/item/${id}.png`;
}

export function getChampionImage(name: string): string {
  return `/champions/${name}.png`;
}

export function getChampionSplashImage(name: string): string {
  return `https://ddragon.leagueoflegends.com/cdn/img/champion/loading/${name}_0.jpg`;
}
